<div class="plor-partner-area bg-ffffff">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-2 col-6 col-sm-4 col-md-4">
                <div class="plor-partner-item wow animate__animated animate__fadeInUp" data-wow-delay="100ms" data-wow-duration="1000ms">
                    <img src="{{src1}}" width="{{width}}" alt="{{title1}}">
                </div>
            </div>
            <div class="col-lg-2 col-6 col-sm-4 col-md-4">
                <div class="plor-partner-item wow animate__animated animate__fadeInUp" data-wow-delay="200ms" data-wow-duration="1000ms">
                    <img src="{{src2}}" width="{{width}}" alt="{{title2}}">
                </div>
            </div>
            <div class="col-lg-2 col-6 col-sm-4 col-md-4">
                <div class="plor-partner-item wow animate__animated animate__fadeInUp" data-wow-delay="300ms" data-wow-duration="1000ms">
                    <img src="{{src3}}" width="{{width}}" alt="{{title3}}">
                </div>
            </div>
            <div class="col-lg-2 col-6 col-sm-4 col-md-4">
                <div class="plor-partner-item wow animate__animated animate__fadeInUp" data-wow-delay="400ms" data-wow-duration="1000ms">
                    <img src="{{src4}}" alt="{{title4}}">
                </div>
            </div>
            <div class="col-lg-2 col-6 col-sm-4 col-md-4">
                <div class="plor-partner-item wow animate__animated animate__fadeInUp" data-wow-delay="500ms" data-wow-duration="1000ms">
                    <img src="{{src5}}" alt="{{title5}}">
                </div>
            </div>
            <div class="col-lg-2 col-6 col-sm-4 col-md-4">
                <div class=" wow animate__animated animate__fadeInUp" data-wow-delay="600ms" data-wow-duration="1000ms">
                    <img src="{{src6}}" width="{{width1}}" alt="{{title6}}">
                </div>
            </div>
        </div>
    </div>
</div>